import { NgModule } from '@angular/core';
import { AngularFireMessagingModule } from '@angular/fire/messaging';

@NgModule({
  imports: [
    AngularFireMessagingModule
  ],
  declarations: [

  ],
  exports: [

  ]
})
export class FirebaseNativeModule {}
